module.exports = __webpack_public_path__ + "static/media/vote-btn-active.7182e997.svg";